import type { LightningGroup, LightningPoint } from './config/types';

const flipX = ([x, y, z]: LightningPoint): LightningPoint => [-x, y, z];

/**
 * THE SAME STRIKE, FIRED FROM THE OTHER SIDE of the engine.
 *
 * A reflection across the engine's vertical centre line. Reflecting a
 * group's whole transform -- M * (T * R * S) applied to M * p -- comes out as
 * a negated position X, negated Y and Z rotations (X is unchanged, and the
 * XYZ Euler order survives because each axis reflects on its own), and every
 * point inside the group negated in X.
 *
 * LINE IDS ARE KEPT on purpose: they seed each bolt's jag, and the twin's
 * own per-cycle group seed is what keeps it from being an exact copy.
 */
export const mirrorLightningGroup = (
  group: LightningGroup
): LightningGroup => ({
  ...group,
  id: `${group.id}-mirror`,
  name: `${group.name} (mirror)`,
  position: flipX(group.position),
  rotationDeg: [
    group.rotationDeg[0],
    -group.rotationDeg[1],
    -group.rotationDeg[2],
  ],
  lines: group.lines.map((line) => ({
    ...line,
    start: flipX(line.start),
    end: flipX(line.end),
    keyframes: line.keyframes?.map((keyframe) => ({
      ...keyframe,
      endOffset: flipX(keyframe.endOffset),
    })),
  })),
});
